import React, { useState, useEffect, useMemo, useCallback } from 'react';
import close from '../Asset/close.svg';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Form } from 'react-bootstrap';
import Table from './tables/assetListTable';
import Alert from './Alert';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Asset_List() {
  let userObj = getUserInfo();
  let navigate = useNavigate();
  let [alert, setAlert] = useState({
    msg: "",
    status: false
  });
  let [sessOut,setSessOut] = useState(false);
  let [region, setRegion] = useState([]);
  let [areas, setAreas] = useState([]);
  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);

  const [copyShow, setCopyShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleShow1 = useCallback(() => {
    setShow1(() => true);
  }, [])
  const handleClose1 = () => {
    setShow1(false);
  }
  useEffect(() => {
    getProductCategory();
    getAllAsset();
    getRegion();
    getDropDown();
  }, [])

  let [allAseet, setAllAsset] = useState([]);
  const getAllAsset = useCallback(() => {
    fetch(environment.baseUrl + "getAssetsInfo", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code === 200) {
          setAllAsset(res.data.result);
          setFilter({
            assetID: "",
            productCategory: "",
            productSubCategory: "",
            serviceBranch: "",
            equipmentType: "",
            areaID: "",
            regionName: ""
          });
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }, [])
  function getRegion() {
    fetch(environment.baseUrl + "getRegions", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    })
      .then((result) => {
        result.json().then((res) => {
          if (res.code == 200) {
            setRegion(res.data.result);
          }
          else if (res.code == 401) {
            setSessOut(true);
          }
          else {
            setRegion([]);
          }
        })
      })
  }
  function getAreas(id) {
    fetch(environment.baseUrl + "getAreaByRegion", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "regionID": id
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code === 200) {
          setAreas(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAreas([]);
        }
      })
    })
  }
  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setCate(resp.data.result.categories);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setCate([]);
        }
      })
    })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }
  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });

  let [branch, setBranch] = useState([])
  let [filter, setFilter] = useState({
    assetID: "",
    productCategory: "",
    productSubCategory: "",
    serviceBranch: "",
    equipmentType: "",
    areaID: "",
    regionName: "",
  })

  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAlert({
              msg: res.msg,
              status: false
          })
        }
      })
    })
  }
  function getBranches(id) {
    fetch(environment.baseUrl + "getBranchByArea", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "areaID": id
      })
    }).then((result) => {

      result.json().then(res => {
        if (res.code == 200) {
          setBranch(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setBranch([]);
        }
      })
    })
  }  
  // for redirect to asset onboarding for edit
  const editAssetData = useCallback((assetInfoID) => {
    navigate(`/asset-onboarding/${assetInfoID}/01`)// new 01 = edit asset
  }, [])
  let [copyAsset, setCopyAsset] = useState("");

  const getCurrentCopyAsset = useCallback((id) => {
    setCopyAsset(id);
    setCopyShow(true)
  }, [])

  function copyAssetDetails() {
    navigate(`/asset-onboarding/${copyAsset}/02`);//new 02=copy
  }
  
  function getAccountFormData(e) {
    if (e.target.name === "productCategory" || e.target.name === "productSubCategory") {
      if (e.target.value == "") {
        setFilter({ ...filter, [e.target.name]: e.target.value });
      }
      else {
        setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
        if (e.target.name === "productCategory") {
          getProductSubCategory(parseInt(e.target.value));
        }
      }
    }
    else if (e.target.name == "regionName") {
      setAreas([]);
      setBranch([]);
      getAreas(parseInt(e.target.value));
      setFilter({ ...filter, [e.target.name]: e.target.value, areaID:"" });
    }
    else if(e.target.name == "areaID")
    {
      setBranch([]);
      getBranches(parseInt(e.target.value));
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }

    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }

  }
  function resetFilter() {
    setSubCate([]);
    setFilter({
      assetID: "",
      productCategory: "",
      productSubCategory: "",
      serviceBranch: "",
      equipmentType: "",
      areaID: "",
      regionName: ""
    });
    getAssetsInfo({});
    handleClose1();
  }
  function getFilterFields() {
    getAssetsInfo(filter);
  }

  function getAssetsInfo() {
    fetch(environment.baseUrl + "getAssetsInfo?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          assetID: filter.assetID,
          productCategory: filter.productCategory,
          productSubCategory: filter.productSubCategory,
          serviceBranchID: parseInt(filter.serviceBranch),
          equipmentType: filter.equipmentType,
          areaID: parseInt(filter.areaID),
          regionID: parseInt(filter.regionName),
        }
      )
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          sessionStorage.removeItem('assetID');
          setAllAsset(resp.data.result)
          handleClose1();
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }
  const columns = useMemo(
    () => [
      {
        Header: 'Equip. Serial No.',
        accessor: 'assetID',
      },
      {
        Header: 'Telematics Device ID ',
        accessor: 'deviceID',
      },
      {
        Header: 'Hour Meter Reading	 ',
        accessor: 'hourMeterReadingAtInstallation',
      },
      {
        Header: 'Equipment Type	 ',
        accessor: 'fuelType',
      },
      {
        Header: 'Product Category ',
        accessor: 'ProductCategory',
      },
      {
        Header: 'Product Sub-Category ',
        accessor: 'productSubcategory',
      },
      {
        Header: 'Product Description ',
        accessor: 'productDescription',
      },
      {
        Header: 'Date of Commissioning ',
        accessor: 'comissioningDate',
      },
      {
        Header: 'Date of Manufacture ',
        accessor: 'manufactureDate',
      },

      {
        Header: 'Subscription Plan ',
        accessor: 'subscriptionPlan',
      },
      {
        Header: 'Subscription Tier ',
        accessor: 'subscriptionTire',
      },
      {
        Header: 'Subscription Start Date ',
        accessor: 'subscriptionStartDate',
      },
      {
        Header: 'Subscription End Date',
        accessor: 'subscriptionEndDate',
      },
      {
        Header: 'Rental of IOT ',
        accessor: 'isRentalOfIoT',
      },
      {
        Header: 'Rental IOT Scheme ',
        accessor: 'rentalOfIoTScheme',
      },
      {
        Header: 'Account Name ',
        accessor: 'accountName',
      },
      {
        Header: 'Is Key Account ',
        accessor: 'isKeyAccount',
      },
      {
        Header: 'Industry',
        accessor: 'industry',
      },
      {
        Header: 'Service Branch',
        accessor: 'serviceBranch',
      },
      {
        Header: 'Sales Branch ',
        accessor: 'salesBranch',
      },
      {
        Header: 'Service Dealer ',
        accessor: 'serviceDealer',
      },
      {
        Header: 'Region Name ',
        accessor: 'regionName',
      },
      {
        Header: 'Area Name ',
        accessor: 'areaName',
      },
      {
        Header: 'Site',
        accessor: 'siteName',
      },
      {
        Header: 'Geofence',
        accessor: 'geofenceName',
      },
      {
        Header: 'Action',
        accessor: 'action',
      }
    ],
    []
  )

  return (
    <div className='main-container'>
      <SessionFun show = {sessOut}></SessionFun>
      <Alert obj={alert} />
      <h4 className='main-heading'>Assets Lists</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;
        <i className='fa fa-angle-right'></i></Link>&nbsp;Asset Lists
      </p>
      <div className="card-box-block mt-3" style={{ width: "100%" }}>
        <Table columns={columns} data={allAseet}
          editFun={editAssetData}
          copyAsset={getCurrentCopyAsset}
          asset={getAllAsset}
          filterShow={handleShow1} />
      </div>

      {/* for copy popup */}
      <Modal show={copyShow} onHide={handleClose1} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>Copy Asset Details</Modal.Title>
          <button onClick={() => setCopyShow(false)} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className="row">
            <p className='text-justify'>This action will copy all the details of this asset & will be added in asset onboarding form. Please click on "OK" to proceed further.</p>
          </div>
          <div className="row text-center mt-3">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={() => setCopyShow(false)}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={copyAssetDetails}>
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* for copy popup */}
      <Modal show={show1} onHide={handleClose1} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>Filter</Modal.Title>
          <button onClick={handleClose1} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className="row">
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Equipment Serial No.</Form.Label>
                <Form.Control className="textbox-back" type='text' placeholder='Enter' name="assetID"
                   onChange={getAccountFormData} value={filter.assetID} />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Equipment Type</Form.Label>
                <Form.Select className="textbox-back" name='equipmentType' value={filter.equipmentType} onChange={getAccountFormData}>
                  <option value="">Select</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Product Category</Form.Label>
                <Form.Select className="textbox-back" name='productCategory' placeholder="Product Category" value={filter.productCategory} onChange={getAccountFormData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Product Sub-Category</Form.Label>
                <Form.Select className="textbox-back"  name='productSubCategory'
                   aria-label="Default select example" value={filter.productSubCategory} onChange={getAccountFormData}>
                  <option value="">Select sub-Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Region</Form.Label>
                <Form.Select className="textbox-back"  name="regionName" value={filter.regionName} onChange={getAccountFormData} >
                  <option value="">Select</option>
                  {
                    region.map((item, index) =>
                      <option key={index} value={item.regionID}>{item.regionName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Area</Form.Label>
                <Form.Select className="textbox-back" name="areaID" value={filter.areaID} onChange={getAccountFormData}>
                  <option value="">Select Area</option>
                  {
                    areas.map((item, index) =>
                      <option key={index} value={item.areaID}>{item.areaName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-sm-4" >
              <Form.Group className="mb-3" >
                <Form.Label>Service Branch</Form.Label>
                <Form.Select className="textbox-back" name='serviceBranch' value={filter.salesBranch} onChange={getAccountFormData}>
                  <option value="">Select Service Branch</option>
                  {
                    branch.map((item, index) =>
                      <option key={index} value={item.branchID}>{item.branchName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>

          </div>
          <div className="row text-center">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={resetFilter}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={getFilterFields} >
                Apply
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default Asset_List